import { auth } from '../../firebase';

export default function EnvIndicator() {
  const env = process.env.REACT_APP_ENV;

  if (env === 'prod') return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 8,
        right: 12,
        background: '#f0f0f0',
        border: '1px solid #ccc',
        borderRadius: 6,
        padding: '6px 10px',
        fontSize: '0.75rem',
        color: '#333',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        zIndex: 1000,
      }}
    >
      <strong>{env.toUpperCase()}</strong> - Firebase: {auth.app.options.projectId}
    </div>
  );
}
